import React, { Components } from 'react';
import HorizontalScroll from 'react-scroll-horizontal';
import { Link } from "react-router-dom";
import {getCDNUrl} from "../../commons/CommonFunctions";

function HashTagsRecentActivity(props) {

    var dateFormat = require('dateformat');
    const convertToFirstCapital = (s) => {
        if (s) {
            if (s.length <= 1) {
                return s.toUpperCase();
            }
            return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
        }
        return s;
    }

    const redirect = (data) => {
        if (data.parentType === 'FORUM') {
            window.location.href = '/forumDetail/' + data.parentId;
        }
        if (data.parentType === 'POST') {
            window.location.href = '/post/' + data.parentId;
        }
        if (data.parentType === 'POST') {
            window.location.href = '/post/' + data.parentId;
        }
        if (data.parentType === 'POLL') {
            window.location.href = '/pollDetail/' + data.parentId;
        }
        if (data.parentType === 'POLLVOTE') {
            window.location.href = '/pollDetail/' + data.parentId;
        }
        if (data.parentType == "APPLYINFUNDRAISE" || data.parentType == "APPLYINSTORYBOOK" ||
            data.parentType == "APPLYINEXPEDITION" || data.parentType == "APPLYINASSIGNMENT" || data.parentType == "APPLYINTRAINING" ||
            data.parentType == "APPLYINEVENT" ||data.parentType == "APPLYINJOB") {
            window.location.href = '/project/feeds/' + data.parentId;
        }
        if (data.parentType === 'STORY') {
            window.location.href = '/explore';
        }
        if (data.parentType === 'EXPLOREBLOG') {
            window.location.href = "explore-detail/blog/" + data.parentId;
        }
        if (data.parentType === 'ASSIGNMENT' || data.parentType === 'TRAINING' || data.parentType === 'EVENT'
            || data.parentType === 'EXPEDITION' || data.parentType === 'STORYBOOK' || data.parentType === 'FUNDRAISE') {
            this.getProjectDetails(data.parentId);
        }
        if (data.parentType === 'FEEDBACK') {
            window.location.href = '/feedback';
        }
        if (data.type === 'CIRCLE') {
            window.location.href = '/community/' + data.parentId;
        }


    }

    const recentActiveparent = { height: `57px` }
    return (
        <div className="expHashSection profrecentact">
            <div className="d-flex align-items-start">
                <h2>Recent Activities</h2>
                {props.hashTagType === 'global' && props.recentActivityListData.length > 4 && (<Link to={"/explore-hashtag/recent-activity/" + props.tagName} className="viewAllAct">
                        <i className="iGrid1" /> <span>View All Activity</span>
                    </Link>)
                }
                {props.hashTagType === 'individual' && props.recentActivityListData.length > 4 && (<Link to={"/explore-hashtag/recent-activity/" + props.tagName} className="viewAllAct">
                        <i className="iGrid1" /> <span>View All Activity</span>
                    </Link>)
                }

            </div>

            <HorizontalScroll style={recentActiveparent} reverseScroll>
                {props.recentActivityListData && props.recentActivityListData.length > 0
                && props.recentActivityListData.map((data, index) => {
                    return <div className="dgcol"  style={ data.parentType === 'JOB' ?{cursor:'default'} : {cursor:'pointer'}}>
                    <a onClick={e => {
                        redirect(data)
                    }} href="javascript:void(0)">
                        <div className="profrcablock" style={ data.parentType === 'JOB' ?{cursor:'default'} : {cursor:'pointer'}}>


                            {(data.parentType === 'POLL' || data.secondaryType === 'POLL') ?
                                <figure className="usersico"><i className="iPolls"/></figure> :
                                (data.parentType === 'FORUM' || data.secondaryType === 'FORUM') ?
                                    <figure className="usersico"><i className="iAddForum"/></figure> :
                                    data.activityAttachmentType === "POST_AUDIO" ?
                                        <figure className="usersico"><i className="iAudio"/></figure> :
                                        data.activityAttachmentType === "POST_LINK" ?
                                            <figure className="usersico"><i className="iLink"/>
                                            </figure> :
                                            (data.activityAttachmentType === "POST_COVER_IMAGE" && data.coverImage === null) ?
                                                <figure className="users"><img
                                                    src="https://cdn.dscovr.com/images/banner-explore-blog-small.webp"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = "https://cdn.dscovr.com/images/banner-explore-blog-small-new.png"
                                                    }} alt=""/>
                                                </figure> :
                                                <figure className="users"><img
                                                    src={data.coverImage != null && data.coverImage != "" ? getCDNUrl(data.coverImage) :
                                                        ((data.parentType === 'JOB' || data.parentType === 'ASSIGNMENT' || data.parentType === 'TRAINING' || data.parentType === 'EVENT' || data.parentType === 'EXPEDITION' || data.parentType === 'STORYBOOK' || data.parentType === 'FUNDRAISE'
                                                            || data.secondaryType === 'JOB' || data.secondaryType === 'ASSIGNMENT' || data.secondaryType === 'TRAINING' || data.secondaryType === 'EVENT' || data.secondaryType === 'EXPEDITION' || data.secondaryType === 'STORYBOOK' || data.secondaryType === 'FUNDRAISE'||
                                                        data.type == "APPLYINJOB" || data.type == "APPLYINFUNDRAISE" || data.type == "APPLYINSTORYBOOK" ||
                                                        data.type == "APPLYINEXPEDITION" || data.type == "APPLYINASSIGNMENT" || data.type == "APPLYINTRAINING" ||
                                                        data.type == "APPLYINEVENT") ? "https://cdn.dscovr.com/images/project-default.jpg" : (data.type === 'CIRCLE' ? "https://cdn.dscovr.com/images/circleDefault.png" : null))}
                                                    alt=""/></figure>}
                            <div className="profrcadesc"  style={ data.parentType === 'JOB' ?{cursor:'default'} : {cursor:'pointer'}}>
                                {data.secondaryType == "COMMENT_REPLY" ?
                                    <h5>Replied on a comment on</h5> :
                                    data.type == "POLLVOTE" ?
                                        <h5>Voted on a Poll on</h5> :
                                        (data.type == "APPLYINJOB" || data.type == "APPLYINFUNDRAISE" || data.type == "APPLYINSTORYBOOK" ||
                                        data.type == "APPLYINEXPEDITION" || data.type == "APPLYINASSIGNMENT" || data.type == "APPLYINTRAINING" ||
                                        data.type == "APPLYINEVENT")?
                                            <h5>Applied for {(data.type === "APPLYINEVENT" || data.type === "APPLYINASSIGNMENT" ||  data.type === "APPLYINEXPEDITION" )? "an" : "a" } {data.type === "APPLYINJOB" ? "Job": data.type === "APPLYINSTORYBOOK" ? "Story Book": data.type === "APPLYINFUNDRAISE" ?"FundRaise" :
                                                data.type === "APPLYINEXPEDITION" ?"Expedition" :data.type === "APPLYINASSIGNMENT" ? "Assignment":data.type === "APPLYINTRAINING" ? "Training":data.type === "APPLYINEVENT" ? "Event": ""} on</h5> :
                                        data.type == "CIRCLE" ?
                                            <h5>Created a {convertToFirstCapital(data.type)} on</h5>:
                                            data.sharedAttachmentType != null ? (<h5>Shared
                                                { data.sharedAttachmentSize >1 ? "" : (data.sharedAttachmentType == "IMAGE" || data.sharedAttachmentType == "AUDIO") ? " an " : " a "} {data.sharedAttachmentType == "COVER_IMAGE" ? "Blog" :
                                                data.sharedAttachmentType == "VIDEO" ? "Video" :
                                                    data.sharedAttachmentType == "AUDIO" ? "Audio" :
                                                        data.sharedAttachmentType == "IMAGE"  &&  data.sharedAttachmentSize >1? "Images" :
                                                            data.sharedAttachmentType == "IMAGE"  &&  data.sharedAttachmentSize === 1? "Image" :
                                                            data.sharedAttachmentType} on</h5>) :

                                            data.type === "COMMENT" ? (<h5>Commented
                                                    on {(data.activityAttachmentType == "POST_IMAGE" || data.activityAttachmentType == "POST_AUDIO" || data.type == "EVENT" || data.type == "ASSIGNMENT" || data.type == "EXPEDITION") ? " an " : " a "} {data.activityAttachmentType == "POST_AUDIO" ? " Audio" :
                                                    data.activityAttachmentType == "POST_COVER_IMAGE" ? " Blog" :
                                                        data.activityAttachmentType == "POST_VIDEO" ? " Video" :
                                                            data.activityAttachmentType == "POST_IMAGE" ? " Image" :
                                                                data.activityAttachmentType == "POST_LINK" ? " Link" :
                                                                    data.parentType == "POST" && data.type == "COMMENT" ? "Post" :
                                                                        convertToFirstCapital(data.secondaryType)} </h5>) :
                                                data.secondaryType && data.secondaryType != null ?
                                                    <h5>Shared { data.sharedAttachmentSize === 1?  "":(data.activityAttachmentType == "POST_IMAGE" || data.activityAttachmentType == "POST_AUDIO" || data.type == "EVENT" || data.type == "ASSIGNMENT" || data.type == "EXPEDITION") ? " an " : " a "}{data.activityAttachmentType == "POST_AUDIO" ? " Audio" :
                                                        data.activityAttachmentType == "POST_COVER_IMAGE" ? " Blog" :
                                                            data.activityAttachmentType == "POST_VIDEO" ? " Video" :
                                                                    data.activityAttachmentType == "IMAGE"  &&  data.sharedAttachmentSize >1? "Images" :
                                                                        data.activityAttachmentType == "IMAGE"  &&  data.sharedAttachmentSize === 1? "Image" :
                                                                    data.activityAttachmentType == "POST_LINK" ? " Link" :
                                                                        data.secondaryType == "EXPLOREBLOG" ? " Blog" :
                                                                            convertToFirstCapital(data.secondaryType)} on</h5> :
                                                    <h5>Posted { data.sharedAttachmentSize >1 ? "" :(data.activityAttachmentType == "POST_IMAGE" || data.activityAttachmentType == "POST_AUDIO" || data.type == "EVENT" || data.type == "ASSIGNMENT" || data.type == "EXPEDITION")  ? " an " :   " a "}{data.activityAttachmentType == "POST_AUDIO" ? " Audio" :
                                                        data.activityAttachmentType == "POST_COVER_IMAGE" ? " Blog" :
                                                            data.activityAttachmentType == "POST_VIDEO" ? " Video" :
                                                                data.activityAttachmentType == "POST_IMAGE"  && data.sharedAttachmentSize >1 ? " Images" :
                                                                    data.activityAttachmentType == "POST_IMAGE"  && data.sharedAttachmentSize === 1 ? " Image":
                                                                    data.activityAttachmentType == "POST_LINK" ? " Link" :
                                                                        convertToFirstCapital(data.type)} on</h5>}
                                <h5>{data.createTime && dateFormat(new Date(data.createTime), "dd mmm yyyy")}</h5>
                            </div>
                        </div>
                    </a>
                </div>
                })
                }
            </HorizontalScroll>
        </div>
    )
}

export default HashTagsRecentActivity;